export enum OrderCurrency {
    USDT = 'usdt',
    GYMNET = 'gymnet',
    UTILITY = 'utility',
    PAP = 'pap',
    ETH = 'eth',
    BTC = 'btc',
    BNB = 'bnb',
    BUSD="busd",
};